import axios from 'axios';
import { urlsServices } from '@/config/urls';
import { getTokenSSO } from '@/utils/index';

export const getUserByCpf = async (cpf) => {
  return await axios
    .get(`${urlsServices.LEGADOWS}dadosServidorPmSicadMinhaContaPeloCpf/${cpf}`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const getFuncoesCpfPM = async (cpf) => {
  return await axios
    .get(`${urlsServices.LEGADOWS}funcoesQueExerceceuPmSicadPorCpf/${cpf}`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const getUserSicad = async (obj) => {
  return await axios
    .post(`${urlsServices.LEGADOWS}pesquisarServidoresPmSicadMinhaConta`, obj, {
      headers: { token: getTokenSSO() },
    })
    .then((response) => response);
};

export const getUnidadesTrabalho = async (cpf) => {
  return await axios
    .get(`${urlsServices.LEGADOWS}unidadesDeTrabalhoSICAD/${cpf}`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const getDependetesPorCpfMilitar = async (obj) => {
  return await axios
    .get(`${urlsServices.LEGADOWS}dependentesServidorSicad`, {
      headers: { token: getTokenSSO() },
      params: obj,
    })
    .then((r) => r);
};

export const getGrauParentesco = async () => {
  return await axios
    .get(`${urlsServices.LEGADOWS}grausParentescosSicad`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const getCategoriaAtendimento = async () => {
  return await axios.get(`${urlsServices.GETWAY}api/categoria-atendimento`).then((r) => r);
};

export const getUnidadeAtendimento = async () => {
  return await axios.get(`${urlsServices.GETWAY}api/unidade-atendimento`).then((r) => r);
};

export const searchCepService = async (cep) => {
  return await axios.get(`${urlsServices.LEGADOWS}logradouroPorCEP/${cep}`).then((r) => r);
};

export const domainPostoGraduacao = async () => {
  return await axios
    .get(`${urlsServices.LEGADOWS}postoGraduacaoPorCorporacaoId/61`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const domainEspecialidade = async () => {
  return await axios
    .get(`${urlsServices.LEGADOWS}especialidadesProfissionais`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const domainSubEspecialidade = async (idEspecialidade) => {
  return await axios
    .get(`${urlsServices.LEGADOWS}subEspecialidadesProfissionais/${idEspecialidade}`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const domainUPM = async () => {
  return await axios
    .get(`${urlsServices.LEGADOWS}unidadesPM`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const domainEstadosCivisSicad = async () => {
  return await axios
    .get(`${urlsServices.LEGADOWS}estadosCivisSicad`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const domainGrauEscolaridade = async () => {
  return await axios
    .get(`${urlsServices.LEGADOWS}grauEscolaridadesSicad`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const funcoesAtivasPorUnidadeId = async (unidadeId) => {
  return await axios
    .get(`${urlsServices.LEGADOWS}funcoesAtivasPorUnidadeId/${unidadeId}`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const imgToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const formatCpf = (text) => {
  const badchars = /[^\d]/g;
  const mask = /(\d{3})(\d{3})(\d{3})(\d{2})/;
  const cpf = String(text).replace(badchars, '');
  return cpf.replace(mask, '$1.$2.$3-$4');
};

export const validarCpf = (cpf) => {
  var Soma = 0;
  var Resto;

  var strCPF = String(cpf).replace(/[^\d]/g, '');

  if (strCPF.length !== 11) return false;

  if (['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'].indexOf(strCPF) !== -1) return false;

  for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);

  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;

  if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;

  for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);

  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;

  return Resto === parseInt(strCPF.substring(10, 11));
};

export const isEmail = (email) => {
  let re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const formatMoney = (valor) => {
  // Remove caracteres não numéricos
  let numericValue = valor.replace(/\D/g, '');

  // Formata para o formato de dinheiro BRL
  // Atualiza o valor formatado no campo de entrada
  valor = Number(numericValue / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return valor;
};
